import { Api } from 'api';

type Props = {
  streamId?: string;
  asOfDate?: string;
  streamCompareId?: string;
};

export function usePerformanceReturnDetailsData({
  streamId,
  asOfDate,
  streamCompareId,
}: Props) {
  const { data, isLoading: isDataLoading } =
    Api.streams.GetPerformanceReturnDetails(streamId, asOfDate);
  const { data: dataCompare, isLoading: isDataCompareLoading } =
    Api.streams.GetPerformanceReturnDetails(streamCompareId, asOfDate);

  return {
    isLoading: isDataLoading || isDataCompareLoading,
    data,
    dataCompare,
  };
}
